import React, { useEffect, useState, useContext } from "react";
import Progress from "./Progress";
import Graph from "../../_dashboard/graph";
import UserContext from "../../../services/context/userContext";
import {getCLientById } from "../../../services/firebase/firestore/getData";
import "./Calendar.scss";


export default function Calendar({ selected_client, client_id, time, currentTime }) {
    const [measurements, setMeasurements] = useState(false);
    const [client_name, setCLientName] = useState(selected_client.first_name + " " + selected_client.last_name);
    const user = useContext(UserContext);

    useEffect(() => {
        localStorage.removeItem("tabIndex")
        setCLientName(selected_client.first_name + " " + selected_client.last_name);
    }, [selected_client])

    useEffect(() => {
        getCLientById(client_id, (result) => {
            setMeasurements(result.measurements);
        })
    }, [time, client_id]);


    return(
        <>
        <div className="c-progress-wrapper">
            <div className="c-page-graph">
              <Graph dayAmount={7}  user={user} clientName={client_name} selectedClientId={client_id}></Graph>
              <Progress measurements={measurements} client_id={client_id} time={time} currentTime={currentTime}></Progress>
            </div>
        </div>
        {/* <div className="c-calendar-wrapper">
            <Mealplan mealplan={mealplan} removeItem={removeItem} addItem={addItem}></Mealplan>
            <Workout workouts={workouts} client_id={client_id} time={time} removeItem={removeItem} addWorkout={addWorkout}></Workout>
        </div> */}
        </>
    );
}